import React from 'react';
import DateFilterTable from '../Content/DateFilterTable';

const SearchAndFilter = ({
  searchTerm,
  setSearchTerm,
  searchPlaceholder = "ค้นหาเอกสาร...",
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  showDateFilter = true,
  onAddNew,
  addButtonText = "เพิ่มใหม่",
  showAddButton = true,
  additionalFilters = null,
  className = "p-3 rounded-3 my-2 shadow-lg bg-white"
}) => {
  
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    // Keep search criteria in localStorage
    localStorage.setItem("searchTerm", value);
  };

  return (
    <div className={className}>
      <div className="row align-items-center">
        {/* Search Input */}
        <div className="col-md-3">
          <div className="input-group">
            <input
              type="text"
              placeholder={searchPlaceholder}
              className="form-control"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <span className="input-group-text">
              <i className="fas fa-search"></i>
            </span>
          </div>
        </div>

        {/* Date Filter */}
        {showDateFilter && (
          <div className="col-md-7 d-flex">
            <DateFilterTable
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </div>
        )}

        {/* Additional Filters */}
        {additionalFilters && (
          <div className={`col-md-${showDateFilter ? '2' : '7'}`}>
            {additionalFilters}
          </div>
        )}

        {/* Add New Button */}
        {showAddButton && (
          <div className={`col-md-${showDateFilter ? '2' : additionalFilters ? '2' : '9'} d-flex justify-content-end`}>
            <button
              onClick={onAddNew}
              className="btn btn-warning text-white"
            >
              {addButtonText} <i className="fa fa-plus"></i>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchAndFilter;
